module.exports = __webpack_public_path__ + "static/img/pullQuery.54bcf76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pullQuery.png
// module id = Ex6X
// module chunks = 208